
<div class="toolbar">
    <v-app-bar flat height="80" color="darkblue" app class="top-navbar pa-0">
      <v-container class="py-0 px-md-6 fill-height">
        <v-row no-gutters align="center">
          <router-link :to="{ name: 'Home' }">
            <img src="/assets/images/bw-legal-logo-inverted.svg" alt="BW Legal Logo" width="97px" height="26px" class="logo"/>
          </router-link>
          <v-toolbar-title class="ml-1 top-navbar__brand">
            {{appTitle}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div class="hidden-md-and-down top-navbar__desktop-actions">
            <v-tabs
              background-color="transparent"
              color="transparent"
              slider-color="transparent"
              hide-slider
              class="top-navbar__tabs"
            >
              <v-tab
                v-for="(item, index) in preServiceTabItems"
                :key="index"
                :to="{ name: item.route }"
                exact
                class="top-navbar__tab"
              >
                {{ item.title }}
              </v-tab>

              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-tab
                    class="top-navbar__tab top-navbar__tab--menu"
                    :class="{ 'top-navbar__tab--active': isServicesActive }"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Services
                    <v-icon x-small class="nav-icon">
                      fa-chevron-down
                    </v-icon>
                  </v-tab>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in serviceMenuItems"
                    :key="`service-${index}`"
                    :to="{ name: item.route }"
                  >
                    <v-list-item-title>
                      {{ item.title }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-tab
                v-for="(item, index) in postServiceTabItems"
                :key="`post-${index}`"
                :to="{ name: item.route }"
                exact
                class="top-navbar__tab"
              >
                {{ item.title }}
              </v-tab>
            </v-tabs>
            <v-btn :to="{ name: 'ContactUs' }" color="primary" outlined large class="ml-4">
              Contact Us
            </v-btn>
          </div>
          <v-app-bar-nav-icon dark @click.stop="sidebar = !sidebar" class="hidden-lg-and-up" aria-label="Menu"></v-app-bar-nav-icon>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-navigation-drawer
      v-model="sidebar"
      temporary
      color="darkblue"
      dark
      app
      class="hidden-lg-and-up">
      <v-list>
        <v-list-item-group color="primary">
          <div v-for="(item, index) in sidebarItems" :key="index">
            <v-list-item
              v-if="item.subLinks.length === 0"
              :to="{ name: item.route }"
              exact
              link>
              <v-list-item-icon>
                <v-icon>{{ getNavIcon(item.route) }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-group v-else no-action :value="subLinksContainActiveRoute(item.subLinks)">
              <template v-slot:activator>
                <v-list-item-icon>
                  <v-icon>{{ getNavIcon(item.route) }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </template>
              <v-list-item
                v-for="(subLink, i) in item.subLinks"
                :key="i"
                :to="{ name: subLink.route }"
                link>
                <v-list-item-title v-text="subLink.title"></v-list-item-title>
              </v-list-item>
            </v-list-group>
          </div>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
</div>
